<template>
  <v-row justify="space-around">
    <v-col cols="auto">
      <v-dialog
        v-model="showModalDelete"
        transition="dialog-bottom-transition"
        max-width="500"
        persistent
      >
        <template>
          <v-card>
            <v-card-title> Atenção </v-card-title>
            <v-card-text>{{ textModalDelete }}</v-card-text>
            <v-card-actions class="justify-end">
              <v-btn @click="emitEventCloseModal" text>Cancelar</v-btn>
              <v-btn @click="emitResponseModalDelete" class="red--text" text>Excluir</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    showModalDelete: Boolean,
    textModalDelete: String
  },

  methods: {
    emitResponseModalDelete() {
      this.$emit("response-button-delete");
    },

    emitEventCloseModal() {
      this.$emit("response-closebutton");
    }
  },
};
</script>